angular.module('impactx.catalog').controller('FixDeliveryDateCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    '$window',
    'trns',
    'fixDeliveryDate',
    FixDeliveryDateCtrl]);

function FixDeliveryDateCtrl($scope, $mdDialog, themeFactory, $window, trns, fixDeliveryDate)
{
    $scope.minDate = new Date();
    $scope.trns = trns;
    $scope.theme = themeFactory.getTheme();
    $scope.fixDeliveryDate = fixDeliveryDate;
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function (fixDeliveryDate)
    {
        $mdDialog.hide(fixDeliveryDate);
    };
}